import React from 'react';
import dayjs from 'dayjs';
import { ResourceSite } from '../../../hooks/resourceSiteHooks';
import { ResourceRequestMetadata } from '../../types/KanbanTypes';
import RequestDetails from './RequestDetails';

interface ApprovedDetailsProps {
  metadata: ResourceRequestMetadata;
  resourceSites?: ResourceSite[];
}

const ApprovedDetails: React.FC<ApprovedDetailsProps> = ({
  metadata,
  resourceSites,
}) => (
  <>
    {/* Show all the same details as request cards. */}
    <RequestDetails metadata={metadata} resourceSites={resourceSites} />

    {/* Additional approved-specific details */}
    <div className="mt-2 small">
      {metadata.logistics_eta && (
        <div>
          <strong>ETA:</strong>{' '}
          {dayjs(metadata.logistics_eta).format('MM/DD/YYYY HH:mm')}
        </div>
      )}
      {metadata.logistics_cost && (
        <div>
          <strong>Cost:</strong> ${metadata.logistics_cost.toLocaleString()}
        </div>
      )}
    </div>
  </>
);

export default ApprovedDetails;
